import { CalendarDate } from './schema/index.js';
import { Festival, Month, Weekday } from './Types.js';
export const daysPerYear = 368;
export const daysPerMonth = 35;
export const daysPerWeek = 5;
export const weeksPerMonth = 7;
export const monthsAndFestivalWeeksPerYear = 13;
export const weekdays = [
    Weekday.Primeday,
    Weekday.Centaxday,
    Weekday.Taungsday,
    Weekday.Zhellday,
    Weekday.Benduday,
];
export const monthsAndFestivalWeeks = [
    {
        name: Festival.FeteWeek,
        shorthand: 'Fete',
        kind: 'festival-week',
        startDay: 0,
        dayCount: 5,
    },
    {
        name: Month.Elona,
        shorthand: '1',
        kind: 'month',
        startDay: 5,
        dayCount: 35,
    },
    {
        name: Month.Kelona,
        shorthand: '2',
        kind: 'month',
        startDay: 40,
        dayCount: 36,
    },
    {
        name: Month.Selona,
        shorthand: '3',
        kind: 'month',
        startDay: 76,
        dayCount: 35,
    },
    {
        name: Month.Telona,
        shorthand: '4',
        kind: 'month',
        startDay: 111,
        dayCount: 35,
    },
    {
        name: Month.Nelona,
        shorthand: '5',
        kind: 'month',
        startDay: 146,
        dayCount: 36,
    },
    {
        name: Month.Helona,
        shorthand: '6',
        kind: 'month',
        startDay: 182,
        dayCount: 35,
    },
    {
        name: Festival.FestivalOfLife,
        shorthand: 'Life',
        kind: 'festival-week',
        startDay: 217,
        dayCount: 5,
    },
    {
        name: Month.Melona,
        shorthand: '7',
        kind: 'month',
        startDay: 222,
        dayCount: 35,
    },
    {
        name: Month.Yelona,
        shorthand: '8',
        kind: 'month',
        startDay: 257,
        dayCount: 36,
    },
    {
        name: Month.Relona,
        shorthand: '9',
        kind: 'month',
        startDay: 293,
        dayCount: 35,
    },
    {
        name: Festival.FestivalOfStars,
        shorthand: 'Stars',
        kind: 'festival-week',
        startDay: 328,
        dayCount: 5,
    },
    {
        name: Month.Welona,
        shorthand: '10',
        kind: 'month',
        startDay: 333,
        dayCount: 35,
    },
];
export const holidays = [
    {
        name: 'Republic Day',
        dayOfTheYear: 75,
    },
    {
        name: 'Productivity Day',
        dayOfTheYear: 181,
    },
    {
        name: 'Harvest Day',
        dayOfTheYear: 292,
    },
];
export const beginningOfNewSithWars = new CalendarDate({
    year: 2007,
    day: 29,
});
export const sithEmpireClaimsHuttSpace = new CalendarDate({
    year: 1793,
    day: 80,
});
//# sourceMappingURL=Constants.js.map